import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 35px);
  padding: 2rem;
  gap: 1rem;
`;

export const StagesScroll = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
  height: calc(100% - 80px);

  &&::-webkit-scrollbar {
    height: 12px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 12px;
  }
`;

export const StagesRow = styled.div`
  display: inline-flex;
  gap: 10px;
  align-items: flex-start;
  padding-right: 2rem;
  min-width: max-content;
`;

export const Title = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
  gap: 10px;

  > * {
    margin-left: 0;
    margin-right: 0;
  }

  .imageDiv {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    width: 50px;
    height: 50px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #ced4da;
  }

  .imageDiv img {
    width: 21px;
    height: 21px;
  }

  .imageDiv.configButton {
    border-radius: 18px;
    border: 1px solid #dadfe6;
    margin-left: 0;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  }

  .imageDiv.configButton svg {
    font-size: 18px;
    color: #8a919d;
    stroke-width: 2.1;
  }

  .imageDiv.sortButton {
    gap: 8px;
    width: fit-content;
    padding: 10px 14px;
    border: 1px solid #ced4da;
    margin-left: 0;
  }

  .imageDiv.sortButton i {
    font-size: 16px;
    color: #7e8695;
  }

  .imageDiv.sortButton span {
    font-size: 12px;
    font-weight: 500;
    color: #7e8695;
    white-space: nowrap;
  }

  .filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #fff;
    width: 400px;
    height: 50px;
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 8px;
  }

  .filters {
    display: flex;
    gap: 10px;

    > * {
      margin-left: 0;
      margin-right: 0;
    }
  }

  .filterButton {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    color: #7e8695;
    padding: 8px 12px;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 8px;
    cursor: pointer;
  }
`;

export const CardTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 5px;

  .name {
    font-size: 16px;
    font-weight: 600;
    min-width: 0;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  .position {
    border-radius: 10px 10px 0 10px;
    padding: 10px 12px;
    color: #fff;
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

export const CreateCard = styled.div`
  display: flex;
  border-radius: 0 0 10px 10px;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  cursor: pointer;

  &:hover {
    background-color: #e3e3e3;
  }
`;

export const StageColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  flex-shrink: 0;
  border: 1px solid #d2d2d2;
  background-color: #fff;
  padding: 8px 12px;
  border-radius: 10px;
  height: calc(100vh - 200px);
`;

export const StageCardsList = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;
  background-color: #fff;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px 4px 4px 0;

  .contactCard {
    display: flex;
    flex-direction: column;
    border: 1px solid #c4ccd8;
    border-radius: 10px;
    padding: 10px;
    gap: 10px;
    cursor: pointer;
  }

  .tags {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 6px;
    padding: 6px 0;
    margin: -6px 0;
  }

  .tags.expanded {
    display: flex;
    flex-wrap: wrap;
    align-items: start;
  }

  .tag {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 3px;
    border-radius: 999px;
    overflow: hidden;
    font-size: 0;
    color: transparent;
    transition: height 0.15s ease, font-size 0.15s ease, color 0.15s ease,
      padding 0.15s ease;
  }

  .tags.expanded .tag {
    width: auto;
    max-width: 100%;
    min-height: 24px;
    height: auto;
    padding: 4px 8px;
    font-size: 10px;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .name {
    display: flex;
    align-items: center;
    gap: 3px;
    color: #000;
  }

  .divisor {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  .infos {
    display: flex;
    flex-direction: column;
    width: 50%;
    font-size: 12px;
    gap: 5px;
  }

  .info {
    display: flex;
    flex-direction: column;
  }

  .title {
    color: #999999;
  }

  .data {
    display: flex;
    flex-direction: column;
    align-items: end;
    width: 50%;
    font-size: 12px;
    color: #4c5862;
  }

  .textInfo {
    color: #4c5862;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 8px;
  }
`;

export const Adjustments = styled.div`
  display: flex;
  position: relative;
  align-items: center;

  .buttons {
    display: flex;
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    padding: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    z-index: 1000;
    flex-direction: column;
    width: max-content;
    gap: 8px;
  }

  .option {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #f8f9fb;
    color: #2f3542;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
  }

  .sortButtons {
    min-width: 260px;
  }

  .sortOption {
    justify-content: flex-start;
  }

  .sortOption.selected {
    background: #eceff3;
    border-color: #d5dbe3;
  }
`;

export const FilterButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;

  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #14223b;
    border-radius: 6px;
    border: 1px solid #ced4da;
    padding: 10px 12px;
    width: 50%;
    font-weight: 600;
    gap: 10px;
  }

  .clearFiltersButton:hover {
    background: #fff;
    color: #14223b;
    border-color: #ced4da;
  }
`;

export const FilterSidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 14px;
  padding-top: 10px;
`;

export const FilterFields = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 14px;

  .filterField {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 12px;
    height: 38px;
  }

  .sourceFilter {
    display: flex;
    align-items: center;
    height: 38px;
    width: 100%;
  }
`;
